import React, { useState } from 'react';
import { useLanguage } from '../../Services/LanguageContext';
import StatsOverview from './StatsOverview';
import UserManagement from './UserManagement';
import ActivityFeed from './ActivityFeed';
import './admin.css';

type AdminTab = 'stats' | 'users' | 'activity';

const AdminPage = () => {
    const { t } = useLanguage();
    const [activeTab, setActiveTab] = useState<AdminTab>('stats');

    return (
        <div className='flex flex-col w-full' style={{ animation: 'fade-in 0.3s ease' }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '32px',
                    paddingBottom: '20px',
                    borderBottom: '1px solid var(--border-color)',
                }}
            >
                <h1
                    style={{
                        fontSize: '32px',
                        fontWeight: 700,
                        margin: 0,
                        background: 'linear-gradient(135deg, var(--text-primary), var(--accent-purple))',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                    }}
                >
                    {t('adminPanel')}
                </h1>
            </div>

            <div className='admin-tabs'>
                <button
                    className={`admin-tab ${activeTab === 'stats' ? 'active' : ''}`}
                    onClick={() => setActiveTab('stats')}
                >
                    {t('statistics')}
                </button>
                <button
                    className={`admin-tab ${activeTab === 'users' ? 'active' : ''}`}
                    onClick={() => setActiveTab('users')}
                >
                    {t('users')}
                </button>
                <button
                    className={`admin-tab ${activeTab === 'activity' ? 'active' : ''}`}
                    onClick={() => setActiveTab('activity')}
                >
                    {t('activity')}
                </button>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', paddingRight: '8px' }}>
                {activeTab === 'stats' && <StatsOverview />}
                {activeTab === 'users' && <UserManagement />}
                {activeTab === 'activity' && <ActivityFeed />}
            </div>
        </div>
    );
};

export default AdminPage;
